module.exports = __webpack_public_path__ + "static/media/Hamaei.d358d122.pdf";